import "./App.css";
import { bootstrapCameraKit } from "@snap/camera-kit";
import { createMediaStreamSource, Transform2D } from "@snap/camera-kit";
import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

function App() {
  const canvasRef = useRef(null);
  const sessionRef = useRef(null);
  const streamRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  let isPortrait;

  const LENS_ID = "d721b7e3-0464-44af-83ca-f7abd85c5f73";
  const GROUP_ID = "fdff0f44-7f89-47df-98d2-86c49a073fa1";

  window
    .matchMedia("(orientation: portrait)")
    .addEventListener("change", (e) => {
      if (e.matches) {
        isPortrait = true;
      } else {
        isPortrait = false;
      }
    });

  useEffect(() => {
    let isMounted = true;

    (async function main() {
      if (!canvasRef.current) return;

      try {
        const apiToken = process.env.REACT_APP_SNAP_API_TOKEN;

        const cameraKit = await bootstrapCameraKit({ apiToken });

        if (!isMounted) return;

        const session = await cameraKit.createSession({
          liveRenderTarget: canvasRef.current,
        });
        sessionRef.current = session;

        session.events.addEventListener("error", (event) => {
          if (event.detail.error.name === "LensExecutionError") {
            console.log(
              "The current Lens encountered an error and was removed.",
              event.detail.error,
            );
          }
        });

        const stream = await navigator.mediaDevices.getUserMedia({
          video: {
            facingMode: "environment",
            height: { ideal: 1920 },
          },
        });
        streamRef.current = stream;

        if (!isMounted) {
          stream.getTracks().forEach((track) => track.stop());
          return;
        }

        const source = createMediaStreamSource(stream, {
          // transform: Transform2D.MirrorX,
          cameraType: "back",
        });
        await session.setSource(source);

        const lens = await cameraKit.lensRepository.loadLens(LENS_ID, GROUP_ID);
        await session.applyLens(lens);

        await session.play();
        console.log("Lens rendering has started!");
        setIsLoading(false);
        //
        //
      } catch (error) {
        console.error("Error initializing Camera Kit:", error);
      }
    })();

    return () => {
      isMounted = false;

      if (streamRef.current) {
        streamRef.current.getTracks().forEach((track) => track.stop());
      }

      if (sessionRef.current) {
        sessionRef.current.pause();
      }
    };
  }, []);

  return (
    <div className="content-container">
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-content">
            <div className="loading-spinner"></div>
            <p className="loading-text">Loading...</p>
          </div>
        </div>
      )}
      <canvas
        className={`snap-canvas ${isPortrait ? "portrait" : "landscape"}`}
        ref={canvasRef}
      />
    </div>
  );
}

export default App;
